import { render } from "./DashboardSidebar.vue?vue&type=template&id=fe5f5f54"
import script from "./DashboardSidebar.vue?vue&type=script&lang=js"
export * from "./DashboardSidebar.vue?vue&type=script&lang=js"
script.render = render

export default script